import axios from '@/util/axios';

const state = {
    current: null,
    conferences: [],
};

// getters
const getters = {
    current: (state) => {
        const visible = state.conferences.filter(e => e.visible);
        if (state.current) {
            return visible.find(e => e.type == state.current.type && e.year == state.current.year)
                || visible[0];
        }
        return visible[0];
    },
    all: (state) => state.conferences.filter(e => e.visible)
}

// actions
const actions = {
    async changeCurrent({ commit }, payload) {
        commit('setCurrent', payload);
    },

    //async init({ commit }) {
    //    let conferences = (await axios.get('public/conferences')).data;
    //    console.log("Conferences from API:", conferences);
    //    var mappedData = conferences.map(function (e) {
    //        return {
    //            key: `${e.conferenceYear}-${e.conferenceType}`,
    //            type: e.conferenceType,
    //            year: e.conferenceYear,
    //            visible: e.visible,
    //            description: e.description.map(function (d) {
    //                return {
    //                    name: d.name,
    //                    topic: d.description,
    //                    date: d.description2,
    //                    logo: d.logotype,
    //                    logoImg: axios.getFileUrl(d.logotype),
    //                    logoBrightImg: axios.getFileUrl(d.logotype)
    //                }
    //            })
    //        }
    //    });
    //    commit('setConferences', mappedData);
    //}
    async init({ commit, state }) {
        let response = await axios.get('public/conferences');
        let conferences = response.data;
        let mappedData = conferences.map(e => {
            let descriptionMap = {};

            if (Array.isArray(e.description)) {
                e.description.forEach(d => {
                    descriptionMap[d.language] = {
                        name: d.name || "Brak nazwy",
                        topic: d.description || "",
                        date: d.description2 || "",
                        logo: d.logotype || "",
                        logoImg: d.logotype ? axios.getFileUrl(d.logotype) : "",
                        logoBrightImg: d.logotype ? axios.getFileUrl(d.logotype) : ""
                    };
                });
            }

            return {
                key: `${e.conferenceYear}-${e.conferenceType}`,
                type: e.conferenceType,
                year: e.conferenceYear,
                visible: e.visible,
                description: descriptionMap
            };
        });

        commit('setConferences', mappedData);

        const visible = mappedData.filter(e => e.visible);
        const currentIsValid = state.current &&
            visible.some(e => e.type == state.current.type && e.year == state.current.year);
        if (!currentIsValid) {
            commit('setCurrent', visible[0] || null);
        }
    }
    
}

// mutations
const mutations = {
    resetCurrent(state) {
        const visible = state.conferences.filter(e => e.visible);
        if (visible.length) {
            state.current = { type: visible[0].type, year: visible[0].year };
        } else {
            state.current = null;
        }
    },
    setCurrent(state, payload) {
        state.current = payload ? { type: payload.type, year: payload.year } : null;
    },
    setConferences(state, payload) {
        state.conferences = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}